import { render, staticRenderFns } from "./activityDetailPage.vue?vue&type=template&id=24241e8e&scoped=true"
import script from "./activityDetailPage.vue?vue&type=script&lang=js"
export * from "./activityDetailPage.vue?vue&type=script&lang=js"
import style0 from "./activityDetailPage.vue?vue&type=style&index=0&id=24241e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24241e8e",
  null
  
)

export default component.exports